/**
 * The QR code of the menu on the net, as KellerLog's (qr.ts there, F22): made in the browser, also
 * offline. Medium error correction, a quiet zone of four modules, no logo in the middle.
 */
import qrcode from "qrcode-generator";

const QUIET = 4;

/** The dark modules of a link, row by row. */
export function qrMatrix(text: string): boolean[][] {
  const qr = qrcode(0, "M");
  qr.addData(text, "Byte");
  qr.make();
  const n = qr.getModuleCount();
  return Array.from({ length: n }, (_, r) => Array.from({ length: n }, (_, c) => qr.isDark(r, c)));
}

/** As SVG, one path, scales to any size (for the printer). */
export function qrSvg(text: string, title = ""): string {
  const m = qrMatrix(text);
  const size = m.length + 2 * QUIET;
  let d = "";
  m.forEach((row, r) => row.forEach((dark, c) => dark && (d += `M${c + QUIET} ${r + QUIET}h1v1h-1z`)));
  const t = title.replace(/&/g, "&amp;").replace(/</g, "&lt;");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges">${t ? `<title>${t}</title>` : ""}<rect width="${size}" height="${size}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
}

/** As PNG of about `px` pixels: whole pixels per module, so the edges stay sharp. */
export function qrPng(text: string, px: number): Promise<Blob> {
  const m = qrMatrix(text);
  const modules = m.length + 2 * QUIET;
  const scale = Math.max(1, Math.round(px / modules));
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = modules * scale;
  const ctx = canvas.getContext("2d")!;
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#000";
  m.forEach((row, r) => row.forEach((dark, c) => dark && ctx.fillRect((c + QUIET) * scale, (r + QUIET) * scale, scale, scale)));
  return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("PNG ließ sich nicht erzeugen"))), "image/png"));
}
